module.exports = __webpack_public_path__ + "static/media/appstore_copy.c2114077.png";